<template>
    <ClockCreationButton :empty="false"></ClockCreationButton>
</template>

<script>
    import store from '@/store/index.js'
    import Translations from '@/store/translations';
    import ClockCreationButton from './ClockCreationButton.vue'

    export default {
        name: "ClockSectionActions",
        store,
        components: {
            ClockCreationButton
        },
        computed: {
            Translations: () => Translations,
        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>